var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row d-flex justify-content-center"},[_c('div',{staticClass:"col-md-6"},[_c('modal-rec-facial')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }